import { Component, Input } from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';

@Component({
    selector: 'agpr-email-preview-dialog',
    templateUrl: './email-preview-dialog.component.html',
    styleUrls: ['./email-preview-dialog.component.scss'],
    standalone: false
})
export class EmailPreviewDialogComponent extends AbstractDialogComponent {
    readonly buttonTypesEnum = ButtonTypesEnum;

    @Input() previewHtml: string;

    id: string = 'emailPreviewDialog';

    constructor(
        public coreDialogService: CoreDialogService,
    ) {
        super(coreDialogService, 'EmailPreviewDialog');
    }


    close(): void {
        this.closeDialog(true);
    }
}
